import apiClient from '../../../services/apiClient'
import { DashboardImage } from '../AdminShared'

function featurePayload(mode) {
  if (mode === 'remove') {
    return { featured: false, featuredStartsAt: null, featuredEndsAt: null }
  }

  const now = new Date()
  const startsAt = now.toISOString()

  if (mode === 'friday') {
    const friday = new Date(now)
    const daysUntilFriday = (5 - friday.getDay() + 7) % 7 || 7
    friday.setDate(friday.getDate() + daysUntilFriday)
    friday.setHours(23, 59, 0, 0)
    return { featured: true, featuredStartsAt: startsAt, featuredEndsAt: friday.toISOString() }
  }

  if (mode === 'seven-days') {
    return { featured: true, featuredStartsAt: startsAt, featuredEndsAt: new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString() }
  }

  return { featured: true, featuredStartsAt: startsAt, featuredEndsAt: null }
}

export function HomepageControl({ apiToken, auctionRows = [], listingRows = [], onRefresh }) {
  const featuredAuctions = auctionRows.filter((row) => row.rawFeatured)
  const featuredListings = listingRows.filter((row) => row.rawFeatured)

  const updateAuction = async (row, mode) => {
    if (!apiToken || !row.rawId) return
    try {
      await apiClient.updateAuction(apiToken, row.rawId, featurePayload(mode))
      await onRefresh?.(mode === 'remove' ? 'Auction removed from homepage' : 'Auction homepage schedule updated')
    } catch (error) {
      await onRefresh?.(error.message || 'Homepage auction update failed')
    }
  }

  const updateListing = async (row, mode) => {
    if (!apiToken || !row.rawId) return
    try {
      await apiClient.updateBuyNowListing(apiToken, row.rawId, featurePayload(mode))
      await onRefresh?.(mode === 'remove' ? 'Shop item removed from homepage' : 'Shop homepage schedule updated')
    } catch (error) {
      await onRefresh?.(error.message || 'Homepage shop update failed')
    }
  }

  return (
    <section className="tactical-card obc-admin__builder">
      <div className="obc-admin__panel-head">
        <div>
          <h2>Homepage Control</h2>
          <span>Manage the visitor-facing featured auction and buy-now lanes</span>
        </div>
      </div>
      <div className="obc-order-admin-grid">
        {auctionRows.map((row) => (
          <article key={`home-auction-${row.rawId || row.lot}`}>
            <DashboardImage src={row.image} alt={row.lot} />
            <div>
              <strong>{row.lot}</strong>
              <span>Auction / {row.type} / {row.status}</span>
              <small>{row.featured} / closes {row.close}</small>
              <small>Feature window: {row.featureWindow}</small>
            </div>
            <div className="obc-consignment-admin-actions">
              <button type="button" onClick={() => updateAuction(row, 'now')}>Now</button>
              <button type="button" onClick={() => updateAuction(row, 'seven-days')}>7 Days</button>
              <button type="button" onClick={() => updateAuction(row, 'friday')}>Friday</button>
              <button type="button" onClick={() => updateAuction(row, 'remove')}>Remove</button>
            </div>
          </article>
        ))}
        {listingRows.map((row) => (
          <article key={`home-listing-${row.rawId || row.item}`}>
            <DashboardImage src={row.image} alt={row.item} />
            <div>
              <strong>{row.item}</strong>
              <span>Buy Now / {row.category} / {row.price}</span>
              <small>{row.featured} / {row.inventory} / {row.status}</small>
              <small>Feature window: {row.featureWindow}</small>
            </div>
            <div className="obc-consignment-admin-actions">
              <button type="button" onClick={() => updateListing(row, 'now')}>Now</button>
              <button type="button" onClick={() => updateListing(row, 'seven-days')}>7 Days</button>
              <button type="button" onClick={() => updateListing(row, 'friday')}>Friday</button>
              <button type="button" onClick={() => updateListing(row, 'remove')}>Remove</button>
            </div>
          </article>
        ))}
      </div>
      <div className="obc-admin__settings-grid">
        <article><strong>Featured auctions</strong><span>{featuredAuctions.length} lots active on the visitor homepage.</span></article>
        <article><strong>Shop spotlights</strong><span>{featuredListings.length} buy-now items active on the visitor homepage.</span></article>
        <article><strong>Schedule logic</strong><span>Visitor pages only show featured items inside their active window.</span></article>
      </div>
    </section>
  )
}

export function AdminContentModule({ apiToken, auctionRows, listingRows, onRefresh }) {
  return (
    <div className="obc-admin__section">
      <HomepageControl apiToken={apiToken} auctionRows={auctionRows} listingRows={listingRows} onRefresh={onRefresh} />
    </div>
  )
}
